module.exports = __webpack_public_path__ + "img/so-meet.bc480d19.png";